export default ($http) => ({
  continueAiConversation(conversationId, payload) {
    return $http.post(`continue-openai-suggestion/${conversationId}`, { body: payload, timeout: 100000 })
  },
  getAiTextNextPortion(aiRequestId, startSymbolIndex) {
    return $http.get(`openai-next-portion/${aiRequestId}/start-symbol/${startSymbolIndex}`)
  },
  getPreferencesForUnit(unitId, categoryId) {
    return $http.get(`unit/${unitId}/openai-preferences/${categoryId}`)
  },
  getFaifToken() {
    return $http.post('faif-renew-token')
  },
  getLessonInitialData(lessonId, payload) {
    return $http.post(`lesson/${lessonId}/get-initial-ai-settings`, { body: payload, timeout: 100000 })
  },
  getUnitInitialData(unitId, categoryId, payload) {
    return $http.post(`unit/${unitId}/category/${categoryId}/get-initial-ai-settings`, { body: payload, timeout: 100000 })
  },
  saveFaifMessageStatistics(aiRequestId, payload) {
    return $http.post(`faif-save-details/${aiRequestId}`, { body: payload, timeout: 100000 })
  }
})
